export const DOSTAVA_V1ResourcesEN: DOSTAVA_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errorMissingInput: "Please fill in all fields",
  errors: {
    registerPic: "The picture you are uploading is too large.",
  },
  input: {
    signatureTitle: "Signature",
    datum: {
      label: "Date",
      placeholder: "Please enter date",
      name: "datum",
    },
    ispravnaPosiljka: {
      label: "Is the shipment correct?",
      placeholder: "Please enter if the shipment is correct",
      name: "ispravnaPosiljka",
    },
    dokument: {
      label: "Document",
      placeholder: "Please enter document",
      name: "dokument",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    korektivnaMjera: {
      label: "Corrective measure",
      placeholder: "Please enter corrective measure",
      name: "korektivnaMjera",
    },
    potpisPrimalac: {
      label: "Please sign the delivery",
      placeholder: "",
      name: "potpisPrimalac",
    },
    primalac: {
      label: "Recipient name",
      placeholder: "Please enter recipient name",
      name: "primalac",
    },
    primjedba: {
      label: "Remark/Note",
      placeholder: "Please enter remark",
      name: "primjedba",
    },
    brojRacuna: {
      label: "Invoice/delivery note number",
      placeholder: "Please enter invoice/delivery note number",
      name: "brojRacuna",
    },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  dropdownOptions: {
    da: "Yes",
    ne: "No",
    undefined: "Please select field",
  },
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ispravnaPosiljka: InputField;
  dokument: InputField;
  korektivnaMjera: InputField;
  potpisPrimalac: InputField;
  primalac: InputField;
  primjedba: InputField;
  brojRacuna: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

interface IErrors {
  registerPic: string;
}

export interface DOSTAVA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownOptions: IDropdownOptions;
  errors: IErrors;
}
